export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/brand-discover.a39da4b2.svg","height":16,"width":26,"blurWidth":0,"blurHeight":0};